export const RESOURCES = {
  "what-is-a-christian": {
    slug: "what-is-a-christian",
    title: "What Is a Christian?",
    short: "It's simpler - and better - than most people think.",
    icon: "Cross",
    intro:
      "A Christian isn't someone who has it all together, grew up in church, or follows a list of rules. A Christian is simply someone who belongs to Jesus Christ.",
    points: [
      {
        text: "A Christian is someone who has received Jesus. Not a religion, not a family tradition - a person. When you believe in Him and receive Him, God Himself makes you His child.",
        verse: "Yet to all who did receive him, to those who believed in his name, he gave the right to become children of God.",
        ref: "John 1:12",
      },
      {
        text: "A Christian is someone who has been made new. Following Jesus isn't behavior modification - it's transformation. God doesn't patch up the old you; He gives you a brand-new start.",
        verse: "If anyone is in Christ, the new creation has come: The old has gone, the new is here!",
        ref: "2 Corinthians 5:17",
      },
      {
        text: "A Christian is someone in a relationship, not a religion. Jesus didn't come to hand you rules; He came to bring you back to the God who made you and loves you.",
        verse: "Now this is eternal life: that they know you, the only true God, and Jesus Christ, whom you have sent.",
        ref: "John 17:3",
      },
    ],
    closing: "Here's the best part: you don't clean yourself up first. You come as you are - and He makes you new.",
  },

  "how-to-accept-christ": {
    slug: "how-to-accept-christ",
    title: "How Do I Accept Christ?",
    short: "Three honest steps, one simple prayer.",
    icon: "HeartHandshake",
    intro:
      "Receiving Jesus isn't complicated. God made it simple on purpose - because He wants you.",
    points: [
      {
        text: "Admit your need. Every one of us has sinned and fallen short. That's not an insult - it's the starting point of the good news.",
        verse: "For all have sinned and fall short of the glory of God.",
        ref: "Romans 3:23",
      },
      {
        text: "Believe in Jesus. Believe that He died for your sins and rose again, and that He is Lord. Salvation is a gift - you can't earn it; you can only receive it.",
        verse: "For God so loved the world that he gave his one and only Son, that whoever believes in him shall not perish but have eternal life.",
        ref: "John 3:16",
      },
      {
        text: "Call on Him. Say it out loud. God isn't looking for perfect words - He's listening for an honest heart.",
        verse: "Everyone who calls on the name of the Lord will be saved.",
        ref: "Romans 10:13",
      },
    ],
    prayer: {
      title: "Pray this out loud",
      text: "Jesus, I need You. I believe You died for my sins and rose from the dead. I turn from my way and I choose Your way. Come into my life - be my Lord and my Savior. I am Yours. Amen.",
      note: "If you just prayed that and meant it, heaven is celebrating - and we'd love to celebrate with you. Reach out below.",
    },
    closing: "That's it. Not a process - a person, saying yes to Jesus.",
  },

  "why-come-to-church": {
    slug: "why-come-to-church",
    title: "Why Come to Church?",
    short: "You were never meant to do this alone.",
    icon: "Church",
    intro:
      "You can believe in God and never set foot in a church - so why come? Because you were never meant to do this alone.",
    points: [
      {
        text: "Because God designed faith to be shared. Church isn't a building or an event - it's a family. Encouragement, strength, and real friendship live here.",
        verse: "And let us not give up meeting together, as some are in the habit of doing, but let us encourage one another.",
        ref: "Hebrews 10:25",
      },
      {
        text: "Because it's where you grow. Worship, teaching, and prayer together do something in you that watching from a screen never quite can.",
        verse: "They devoted themselves to the apostles' teaching and to fellowship, to the breaking of bread and to prayer.",
        ref: "Acts 2:42",
      },
      {
        text: "Because when life knocks you down, you need people who will pick you up.",
        verse: "Two are better than one... If either of them falls down, one can help the other up.",
        ref: "Ecclesiastes 4:9-10",
      },
    ],
    closing: "Come as you are. You'll leave different.",
  },

  "baptism-of-the-holy-spirit": {
    slug: "baptism-of-the-holy-spirit",
    title: "Baptism of the Holy Spirit",
    short: "God's promise of power for every believer.",
    icon: "Flame",
    intro:
      "The baptism of the Holy Spirit is God's promise of power for every believer - not for a special few, and not just for Bible times.",
    points: [
      {
        text: "It's a promise for you. When God poured out His Spirit at Pentecost, Peter made it clear: the promise wasn't just for that day, and it wasn't just for them.",
        verse: "The promise is for you and your children and for all who are far off - for all whom the Lord our God will call.",
        ref: "Acts 2:39",
      },
      {
        text: "It's power to live and to witness. The Holy Spirit gives boldness, strength, and help you simply don't have on your own.",
        verse: "But you will receive power when the Holy Spirit comes on you; and you will be my witnesses.",
        ref: "Acts 1:8",
      },
      {
        text: "It's received by simply asking. No striving, no earning, no formula. God is a good Father who loves to give this gift.",
        verse: "How much more will your Father in heaven give the Holy Spirit to those who ask him!",
        ref: "Luke 11:13",
      },
    ],
    prayer: {
      title: "Simply ask Him",
      text: "Father, Your Word says You give the Holy Spirit to those who ask. So I'm asking. Fill me with Your Spirit - with Your power, Your boldness, and Your presence. Jesus, be Lord of my life. Amen.",
      note: "Want to talk more about the Holy Spirit? It's one of our favorite conversations - reach out below.",
    },
    closing: "God isn't holding out on you. Ask - and receive.",
  },

  "grow-closer-to-god": {
    slug: "grow-closer-to-god",
    title: "How to Grow Closer to God",
    short: "Time, honesty, and ten minutes a day.",
    icon: "Sprout",
    intro:
      "Closeness with God works like every other relationship in your life: time, honesty, and consistency. It's simpler than you think.",
    points: [
      {
        text: "Take one step toward Him - and He moves toward you. God isn't distant or reluctant. He draws near to people who draw near to Him.",
        verse: "Draw near to God, and he will draw near to you.",
        ref: "James 4:8",
      },
      {
        text: "Talk to Him honestly, every day. Prayer isn't a performance. Tell Him what's really going on - and hand Him the worries instead of carrying them.",
        verse: "Do not be anxious about anything, but in every situation, by prayer and petition, with thanksgiving, present your requests to God.",
        ref: "Philippians 4:6",
      },
      {
        text: "Read a little of His Word daily. Even ten minutes a day in the Gospels will quietly change how you think, decide, and hope.",
        verse: "Your word is a lamp for my feet, a light on my path.",
        ref: "Psalm 119:105",
      },
      {
        text: "Don't grow alone. You were made for family - a local church strengthens your faith in ways solitude never can.",
        verse: "And let us not give up meeting together, as some are in the habit of doing, but let us encourage one another.",
        ref: "Hebrews 10:25",
      },
    ],
    closing: "Start today. Ten honest minutes with God - that's the whole first step.",
  },

  "overcoming-worry-and-anxiety": {
    slug: "overcoming-worry-and-anxiety",
    title: "Overcoming Worry & Anxiety",
    short: "For the mind that won't stop racing.",
    icon: "CloudSun",
    intro:
      "If your mind won't stop racing, hear this: you're not broken, and you're not failing spiritually. God has a lot to say to anxious hearts.",
    points: [
      {
        text: "God invites you to hand it over. Not manage it better - hand it over. Anxiety is too heavy for you, and it was never yours to carry.",
        verse: "Cast all your anxiety on him because he cares for you.",
        ref: "1 Peter 5:7",
      },
      {
        text: "Trade panic for prayer - with thanksgiving. When worry hits, pray specifically about the very thing you're afraid of, and thank God for what He's already done. Something supernatural follows.",
        verse: "Do not be anxious about anything, but in every situation, by prayer and petition, with thanksgiving, present your requests to God. And the peace of God... will guard your hearts and your minds in Christ Jesus.",
        ref: "Philippians 4:6-7",
      },
      {
        text: "Take tomorrow off your shoulders. You weren't built to carry next month. Today has enough - and God is already waiting in your tomorrow.",
        verse: "Therefore do not worry about tomorrow, for tomorrow will worry about itself.",
        ref: "Matthew 6:34",
      },
      {
        text: "You are not alone in the dark moments. Fear loses its grip when you remember who is standing with you.",
        verse: "So do not fear, for I am with you; do not be dismayed, for I am your God.",
        ref: "Isaiah 41:10",
      },
    ],
    closing: "And if the anxiety feels bigger than a two-minute read can hold - talk to us. We'll pray with you and walk with you.",
  },

  "overcoming-depression": {
    slug: "overcoming-depression",
    title: "Overcoming Depression",
    short: "You are not weak, not forgotten, not alone.",
    icon: "Sunrise",
    intro:
      "If you're in a heavy season, hear this first: you are not weak, you are not forgotten, and you are not alone. God is closest right here.",
    points: [
      {
        text: "God draws near to the brokenhearted - not away from them. Your lowest place doesn't push God away; it pulls Him closer.",
        verse: "The Lord is close to the brokenhearted and saves those who are crushed in spirit.",
        ref: "Psalm 34:18",
      },
      {
        text: "Even giants of the faith walked through darkness. Elijah - one of the greatest prophets - once sat under a tree and wanted to give up. God's response? He fed him, let him rest, and spoke to him in a gentle whisper. No lecture. No shame.",
        verse: "Why, my soul, are you downcast? Why so disturbed within me? Put your hope in God, for I will yet praise him, my Savior and my God.",
        ref: "Psalm 42:11",
      },
      {
        text: "God trades ashes for beauty. Depression says this is permanent. God says it's a season - and He specializes in turning mourning into joy.",
        verse: "...to bestow on them a crown of beauty instead of ashes, the oil of joy instead of mourning.",
        ref: "Isaiah 61:3",
      },
      {
        text: "Hope is a person, and He is holding you. Even when you can't feel Him, you are held.",
        verse: "Be strong and courageous... for the Lord your God goes with you; he will never leave you nor forsake you.",
        ref: "Deuteronomy 31:6",
      },
    ],
    closing: "This season is not your story's ending. Let us walk with you through it.",
  },
};

export const RESOURCE_LIST = Object.values(RESOURCES);
